<template>
  <v-card
    v-if="dataPropietario"
    class="mx-auto mt-2"
    :loading="loading"
    :outlined="outlined"
    :elevation="elevation"
    :raised="raised"
    color="white"
  >
    <v-card-title class="red lighten-1">
      {{nombreApellidos}}
      <v-spacer></v-spacer>
      <v-btn icon dark @click="visualiza = !visualiza">
        <v-icon v-if="visualiza">keyboard_arrow_up</v-icon>
        <v-icon v-else>keyboard_arrow_down</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    
    <!-- Datos formulario -->
    <v-layout wrap v-show="visualiza">
      <v-flex xs12 sm6  class="teal lighten-5">

        <!-- Pantalla 1 -->
        <v-card-text>
          <v-form>
            <v-layout wrap align-center>
              <v-flex xs12>
                <v-text-field
                  class="px-1"
                  v-model="dataPropietario.direccion.calle"
                  label="Dirección de la calle"
                  hint="Dirección de la calle"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field
                  class="px-1"
                  v-model="dataPropietario.direccion.escalera"
                  label="Escalera"
                  hint="Escalera"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field
                  class="px-1"
                  v-model="dataPropietario.direccion.piso"
                  label="Piso"
                  hint="Piso"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field
                  class="px-1"
                  v-model="dataPropietario.direccion.letra"
                  label="Letra"
                  hint="Letra"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field
                  class="px-1"
                  v-model="dataPropietario.direccion.ciudad"
                  label="Ciudad"
                  hint="Ciudad"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field
                  class="px-1"
                  v-model="dataPropietario.direccion.provincia"
                  label="Provincia"
                  hint="Provincia"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field
                  class="px-1"
                  v-model="dataPropietario.direccion.cp"
                  label="Código postal"
                  hint="Código postal"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>

        <v-card-text>
          <h3 class="font-weight-black pl-5 pb-3">El inmueble se trata de...</h3>
          <v-form>
            <v-layout wrap align-center>
              <v-flex xs12>
                <v-radio-group class="py-0 my-0" v-model="dataPropietario.tipoInmueble.tipo" readonly>
                  <v-radio label="Una vivienda" color="primary" value="0"></v-radio>
                  <v-radio label="Un local comercial" color="primary" value="1"></v-radio>
                  <v-radio label="Otro" color="primary" value="2"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs12 v-if="parseInt(dataPropietario.tipoInmueble.tipo) === 2">
                <v-text-field
                  class="px-1"
                  v-model="dataPropietario.tipoInmueble.description"
                  label="Otro"
                  hint="Tipo de inmueble"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>

        <!-- Pantalla 2 -->
        <v-card-text>
          <h3 class="font-weight-black pl-5 pb-3">¿Está empadronado en la vivienda?</h3>
          <v-form>
            <v-layout wrap align-center>
              <v-flex xs12>
                <v-radio-group class="py-0 my-0" v-model="dataPropietario.empadronado" readonly>
                  <v-radio
                    label="SI"
                    color="primary"
                    value="1"
                  ></v-radio>
                  <v-radio
                    label="No"
                    color="primary"
                    value="2"
                  ></v-radio>
                  <v-radio
                    label="No, pero puedo empadronarme"
                    color="primary"
                    value="3"
                  ></v-radio>
                </v-radio-group>
              </v-flex>

              <v-flex xs12 v-if="parseInt(dataPropietario.empadronado) === 5">
                <v-text-field
                  class="px-1"
                  v-model="dataPropietario.relacionInmueble.description"
                  label="Otro"
                  hint="¿Cual es su relación con el inmueble"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>

        <v-card-text>
          <v-form>
            <h3 class="font-weight-black pl-5 pb-3">Relación con el inmueble</h3>
            <v-layout wrap align-center>
              <v-flex xs12>
                <v-radio-group class="py-0 my-0" v-model="dataPropietario.relacionInmueble.tipo" readonly>
                  <v-radio
                    label="Soy propietario/a."
                    color="primary"
                    value="1"
                  ></v-radio>
                  <v-radio
                    label="Soy inquilino/a (solo para viviendas)"
                    color="primary"
                    value="2"
                  ></v-radio>
                  <v-radio
                    label="Otro"
                    color="primary"
                    value="3"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
              <!-- <template v-if="parseInt(dataPropietario.relacionInmueble.tipo) === 2 && parseInt(dataPropietario.empadronado) === 1">
                <v-flex xs12>
                  <v-alert 
                    border="top"
                    colored-border
                    type="info"
                    elevation="2"
                  >
                    <div class="pb-2">Cuando la vivienda se encuentra alquilada, debe enviarnos copia del contrato de arrendamiento en vigor y del último recibo pasado al cobro. (No se admite compromiso de alquiler)</div>
                    <inputFile :files="dataPropietario.filesAlquiler" metaCode="filesAlquiler" meta="prueba alquiler" :formulario="namedForm" @urlFile="newFileUp" />
                  </v-alert>
                </v-flex>
              </template> -->
              <v-flex xs12 v-if="parseInt(dataPropietario.relacionInmueble.tipo) === 3">
                <v-text-field
                  class="px-1"
                  v-model="dataPropietario.relacionInmueble.description"
                  label="Otro"
                  hint="¿Cual es su relación con el inmueble"
                  readonly
                ></v-text-field>
              </v-flex>
              <template v-if="parseInt(dataPropietario.relacionInmueble.tipo) === 1">
                <h3
                  class="font-weight-black pl-5 pb-3"
                >Porcentaje de participación:</h3>
                <v-flex xs12 sm6>
                  <v-text-field
                    class="px-1"
                    v-model="dataPropietario.relacionInmueble.propiedadPercent"
                    type="number"
                    min="0"
                    max="100"
                    hint="Por ejemplo si es un matrimonio en gananciales, cada uno deberá poner 50%"
                    readonly
                  ></v-text-field>
                </v-flex>
              </template>
            </v-layout>
          </v-form>
        </v-card-text>

        <!-- Pantalla 3 -->
        <v-card-text>
          <h3 class="font-weight-black pl-5 pb-3">Se trata de una....</h3>
          <v-form>
            <v-layout wrap align-center>
              <v-flex xs12>
                <v-radio-group class="py-0 my-0" v-model="dataPropietario.calificacionJuridica" readonly>
                  <v-radio
                    label="Persona física, con nacionalidad española, o extranjero con residencia legal en España"
                    color="primary"
                    value="1"
                  ></v-radio>
                  <v-radio
                    :disabled="dataPropietario.empadronado === '1'"
                    label="Persona jurídica u otros"
                    color="primary"
                    value="2"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>

        <!-- Pantalla 4 -->
        <template v-if="CA === 'AN'">
          <!-- Declaración responsable -->
          <v-card-text>
            <h3 class="font-weight-black pl-5 pb-3">DECLARACION RESPONSABLE</h3>
            <v-form>
              <v-layout wrap align-center>
                <v-flex xs12>
                  <h3 class="font-weight-black pl-5 pb-3">3. Relativo a resoluciones administrativas o judiciales:</h3>
                </v-flex>
                <v-flex xs12>
                  <v-radio-group class="py-0 my-0" v-model="dataPropietario.resolucionAmin" readonly>
                    <v-radio label="No he sido objeto de resolución administrativa o judicial firme de reintegro" color="primary" value="1"></v-radio>
                    <v-radio label="He sido objeto de resolución administrativa o judicial firme de reintegro, acreditando mediante la documentación que se adjunta a esta declaración, el:" color="primary" value="2"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 v-if="parseInt(dataPropietario.resolucionAmin) === 2">
                  <v-radio-group class="py-0 my-0" v-model="dataPropietario.resolucionAminTipo" readonly>
                    <v-radio label="Ingreso" color="primary" value="1"></v-radio>
                    <v-radio label="Aplazamiento" color="primary" value="2"></v-radio>
                    <v-radio label="Fraccionamiento" color="primary" value="3"></v-radio>
                  </v-radio-group>
                </v-flex>
                <!-- <v-flex xs12 v-if="textDocument">
                  <v-alert 
                    border="top"
                    colored-border
                    type="info"
                    elevation="2"
                  >
                    <div class="pb-2">Documento acreditativo del {{ textDocument }}</div>
                    <inputFile :files="datosForm.filesDeclaraResponsable" metaCode="filesDeclaraResponsable" meta="justificante de pago" :formulario="namedForm" @urlFile="newFileUp" />
                    <span v-if="datosForm.filesDeclaraResponsable.length < 1" class="caption grey--text">Subir Comprobante {{textDocument}}</span>
                  </v-alert>
                </v-flex> -->
              </v-layout>
            </v-form>
          </v-card-text>
        </template>
        <!-- Persona Jurídica -->
        <template v-if="parseInt(dataPropietario.calificacionJuridica) === 2">
          <v-card-text>
            <h3 class="font-weight-black pl-5 pb-3">PERSONAS JURIDICAS Y OTROS</h3>
            <v-form>
              <v-layout wrap align-center>
                <v-flex xs12>
                  <v-text-field
                    class="px-1"
                    v-model="dataPropietario.pJuridica.razonSocial"
                    label="Razón Social"
                    hint="Incluyendo el tipo de sociedad"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    class="px-1"
                    v-model="dataPropietario.pJuridica.cif"
                    label="CIF"
                    hint="CIF"
                    readonly
                  ></v-text-field>
                </v-flex>
                <h3 class="font-weight-black pl-5 pb-3">Datos del apoderado de la sociedad</h3>
                <v-flex xs12>
                  <v-text-field
                    class="px-1"
                    v-model="dataPropietario.pJuridica.apoderado.nombreApellidos"
                    label="Nombre y apellidos"
                    hint="Nombre y apellidos"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    class="px-1"
                    v-model="dataPropietario.pJuridica.apoderado.nif"
                    label="NIF / NIE"
                    hint="NIF / NIE"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    class="px-1"
                    v-model="dataPropietario.pJuridica.apoderado.tlf1"
                    label="Móvil principal"
                    hint="Móvil principal"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    class="px-1"
                    v-model="dataPropietario.pJuridica.apoderado.tlfs"
                    label="Otros teléfonos"
                    hint="Otros teléfonos"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    class="px-1"
                    v-model="dataPropietario.pJuridica.apoderado.email"
                    label="Email"
                    hint="ejemplo@ejemplo.com"
                    readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
        </template>
        <!-- Persona Física -->
        <template v-else>
          <v-card-text>
            <h3 class="font-weight-black pl-5 pb-3">PERSONAS FISICAS</h3>
            <v-form>
              <v-layout wrap align-center>
                <v-flex xs12>
                  <v-text-field
                    class="px-1"
                    v-model="dataPropietario.pFisica.nombre"
                    label="Nombre"
                    hint="Nombre"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    class="px-1"
                    v-model="dataPropietario.pFisica.apellido1"
                    label="Primer Apellido"
                    hint="Primer Apellido"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    class="px-1"
                    v-model="dataPropietario.pFisica.apellido2"
                    label="Segundo Apellido"
                    hint="Segundo Apellido"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    class="px-1"
                    v-model="dataPropietario.pFisica.nif"
                    label="DNI, NIF, NIE"
                    hint="DNI, NIF, NIE"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    class="px-1"
                    v-model="dataPropietario.pFisica.email"
                    label="Correo Electrónico"
                    hint="ejemplo@ejemplo.com"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    class="px-1"
                    v-model="dataPropietario.pFisica.tlf1"
                    label="Teléfono Móvil principal"
                    hint="Teléfono Móvil principal"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    class="px-1"
                    v-model="dataPropietario.pFisica.tlfs"
                    label="Otros Teléfonos"
                    hint="Otros Teléfonos"
                    readonly
                  ></v-text-field>
                </v-flex>

                <template v-if="CA === 'AN'">
                  <h3 class="font-weight-black pl-5 pb-3 mt-4">Género:</h3>
                  <v-flex xs12>
                    <v-radio-group class="py-0 my-0" v-model="dataPropietario.pFisica.genero" readonly>
                      <v-radio label="Hombre" color="primary" value="1"></v-radio>
                      <v-radio label="Mujer" color="primary" value="2"></v-radio>
                    </v-radio-group>
                  </v-flex>
                </template>

                <h3 v-if="dataPropietario.empadronado === '1'" class="font-weight-black pl-5 pb-3 mt-4">
                  Fecha de nacimiento:
                </h3>
                <h3 v-else class="font-weight-black pl-5 pb-3 mt-4">
                  Fecha de nacimiento:
                </h3>
                <p v-if="dataPropietario.tipoInmueble.tipo === '1'" class="red--text">Esta ayuda complementaria no aplica a locales comerciales</p>
                <v-flex xs12 sm6> 
                  <v-text-field
                    class="px-1"
                    v-model="dataPropietario.pFisica.fechaNacimiento"
                    label="Fecha de nacimiento"
                    hint="AAAA-MM-DD"
                    readonly
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <h3 class="font-weight-black pl-5 pb-3 mt-4">Tiene alguna discapacidad</h3>
                  <v-radio-group class="py-0 my-0" v-model="dataPropietario.pFisica.discapacidad.isDiscapacidad" readonly>
                    <v-radio label="Si" color="primary" value="1"></v-radio>
                    <v-radio label="No" color="primary" value="2"></v-radio>
                  </v-radio-group>
                </v-flex>

                <template v-if="parseInt(dataPropietario.pFisica.discapacidad.isDiscapacidad) === 1">
                  <v-flex xs12>
                    <h3 class="font-weight-black pl-5 pb-3">Indique % de discapacidad</h3>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <v-text-field
                      class="px-1"
                      v-model="dataPropietario.pFisica.discapacidad.grado"
                      type="number"
                      min="0"
                      max="100"
                      label=""
                      hint="%"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <h3 class="font-weight-black pl-5 pb-3">¿Tiene algún grado de movilidad reducida?</h3>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-radio-group class="py-0 my-0" v-model="dataPropietario.pFisica.discapacidad.movilidad" readonly>
                    <v-radio label="Si" color="primary" value="1"></v-radio>
                    <v-radio label="No" color="primary" value="2"></v-radio>
                  </v-radio-group>
                  </v-flex>
                </template>

                <!-- IPREM x 3 <=> 5.5 -->
                <template v-if="CA === 'AN'">
                  <h3 class="font-weight-black pl-5 pb-3 mt-4">Suma de rentas:</h3>
                  <v-flex xs12>
                    <v-radio-group class="py-0 my-0" v-model="iprem" @change="changeIprem" readonly>
                      <v-radio :label="`Inferior o igual a 22.559€`" color="primary" value="1"></v-radio>
                      <v-radio :label="`Entre 22.559€ y 41.358€`" color="primary" value="2"></v-radio>
                      <v-radio :label="`Mayor a 41.358€`" color="primary" value="3"></v-radio>
                      <v-radio label="No lo sé" color="primary" value="4"></v-radio>
                    </v-radio-group>
                  </v-flex>
                </template>
                <template v-else>
                  <v-flex xs12>
                    <h3 class="font-weight-black pl-5 pb-3 mt-4">¿ La suma de todas las rentas es inferior a 22.559€?</h3>
                    <v-radio-group class="py-0 my-0" v-model="dataPropietario.pFisica.ipremX3" readonly>
                      <v-radio label="Si" color="primary" value="1"></v-radio>
                      <v-radio label="No" color="primary" value="2"></v-radio>
                      <v-radio label="No lo sé" color="primary" value="3"></v-radio>
                    </v-radio-group>
                  </v-flex>
                </template>
              </v-layout>
            </v-form>
          </v-card-text>
        </template>

        <!-- Autorizaciones -->
        <v-card-text v-if="CA === 'AN'">
          <h3 class="font-weight-black pl-5 pb-3">CONSENTIMIENTOS:</h3>
          <v-form>
            <v-layout wrap align-center>
              <template v-for="(item, i) in espacialAuthData">
                <template v-if="checkCondi(item)">
                  <h3 class="font-weight-black pl-5 pb-3 mt-4" :key="i">{{ item.text }}</h3>
                  <v-flex xs12  :key="(i+1)*100">
                    <v-radio-group class="py-0 my-0" v-model="dataPropietario.authData[item.campo]" readonly>
                      <v-radio :label="item.text_1" color="primary" value="1"></v-radio>
                      <v-radio :label="item.text_2" color="primary" value="2"></v-radio>
                    </v-radio-group>
                  </v-flex>

                  <!-- <template v-if="parseInt(datosForm.authData[item.campo]) > 1">
                    <v-flex xs12 :key="(i+1)*1000">
                      <v-alert 
                        border="top"
                        colored-border
                        type="info"
                        elevation="2"
                      >
                        <div class="pb-2">Si aún no lo ha hecho, por favor suba aquí la documentación solicitada:</div>
                        <inputFile :files="datosForm[item.file]" :metaCode="item.file" :meta="item.meta" :formulario="namedForm" @urlFile="newFileUp" />
                        <span v-if="datosForm[item.file].length < 1" class="caption grey--text">Subir Archivo/s</span>
                      </v-alert>
                    </v-flex>
                  </template> -->
                </template>
              </template>
            </v-layout>
          </v-form>
        </v-card-text>

        <v-card-text v-else>
          <h3 class="font-weight-black pl-5 pb-3">AUTORIZO a mi Comunidad Autónoma a que pueda consultar la veracidad de los datos proporcionados. La posibilidad de hacer la consulta telemática o de oponerse a la misma y presentar el documento es en aplicación del artículo 28.2 de la Ley 39/2015, de 1 de octubre, de Procedimiento Administrativo Común de las Administraciones Públicas.</h3>
          <v-form>
            <v-layout wrap align-center>
              <v-flex xs12>
                <v-radio-group class="py-0 my-0" v-model="dataPropietario.autorizarDatos" readonly>
                  <v-radio label="Si" color="primary" value="1"></v-radio>
                  <v-radio label="No" color="red" value="2"></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>

            <v-layout wrap align-center>
              <h3 class="font-weight-black pl-5 pb-0 mt-7">Escriba aquí la información que considere relevante:</h3>
              <v-flex xs12>
                <v-textarea
                  v-model="dataPropietario.notas"
                  background-color="amber lighten-4"
                  color="orange orange-darken-4"
                  label="Notas"
                  readonly
                ></v-textarea>
              </v-flex>
            </v-layout>

            <v-layout wrap align-center>
              <v-flex xs12>
                <v-checkbox v-model="dataPropietario.privacidad" readonly>
                  <template v-slot:label>
                    <div>
                      Estoy de acuerdo con los 
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <a
                            target="_blank"
                            href="https://firebasestorage.googleapis.com/v0/b/app-users-cloud.appspot.com/o/html%2Fprivacidad.html?alt=media&token=fc0667fd-8531-4ed2-9088-87c6af61c628"
                            @click.stop
                            v-on="on"
                          >
                            términos y condiciones
                          </a>
                        </template>
                        Abrir en nueva ventana
                      </v-tooltip>
                      de éste formulario*.
                    </div>
                  </template>
                </v-checkbox>
              </v-flex>
            </v-layout>

          </v-form>
        </v-card-text>
      </v-flex>

      <!-- Resumen -->
      <v-flex xs12 sm6>
        <h2 class="pl-5">Resumen:</h2>

          <v-card-text>
            <h3 class="my-2">Calificación Jurídica: <small class="teal--text">{{ `${isEmpresa ? "Persona JURÍDICA" : "Persona FÍSICA"}` }}</small></h3>
            <!-- Calificación Jurídica EMPRESA -->
            <template v-if="isEmpresa">
              <p>Razón Social: <span class="teal--text">{{dataPropietario.pJuridica.razonSocial || ' -'}}</span></p>
              <p>CIF: <span class="teal--text">{{dataPropietario.pJuridica.cif || ' -'}}</span></p>
              <p>Apoderado: <span class="teal--text">{{dataPropietario.pJuridica.apoderado.nombreApellidos || ' -'}}</span></p>
              <p>NIF Apoderado: <span class="teal--text">{{dataPropietario.pJuridica.apoderado.nif || ' -'}}</span></p>
              <p>Email: <span class="teal--text">{{dataPropietario.pJuridica.apoderado.email || ' -'}}</span></p>
              <p>Tlf1: <span class="teal--text">{{dataPropietario.pJuridica.apoderado.tlf1 || ' -'}}</span></p>
              <p>Otros Tlfs.: <span class="teal--text">{{dataPropietario.pJuridica.apoderado.tlfs || ' -'}}</span></p>
            </template>

            <!-- Calificación Jurídica PARTICULAR -->
            <template v-else>
              <p>Nombre: <span class="teal--text">{{dataPropietario.pFisica.nombre || ' -'}}</span></p>
              <p>Apellido 1: <span class="teal--text">{{dataPropietario.pFisica.apellido1 || ' -'}}</span></p>
              <p>Apellido 2: <span class="teal--text">{{dataPropietario.pFisica.apellido2 || ' -'}}</span></p>
              <p>DNI/NIF/NIE: <span class="teal--text">{{dataPropietario.pFisica.nif || ' -'}}</span></p>
              <p>Email: <span class="teal--text">{{dataPropietario.pFisica.email || ' -'}}</span></p>
              <p>Tlf1: <span class="teal--text">{{dataPropietario.pFisica.tlf1 || ' -'}}</span></p>
              <p>Otros Tlfs.: <span class="teal--text">{{dataPropietario.pFisica.tlfs || ' -'}}</span></p>
              <p>F. Nacimiento: <span class="teal--text">{{fechaNacimiento.fecha}} ({{fechaNacimiento.edad}} Años)</span></p>
              
            </template>
          </v-card-text>

          <v-card-text class="my-0 py-0">
            <p>Empadronado: <span class="teal--text">{{isEmpadronado}}</span></p>
            <p>Tipo Inmueble: <span class="teal--text">{{tipoInmueble}}</span></p>
            <p>Relación Inmueble: <span class="teal--text">{{relacionInmueble}}</span></p>
          </v-card-text>

        <!-- Firma -->
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              Firma:
            </v-flex>
            <v-flex xs12>
              <img v-if="propietario.firma" :src="propietario.firma" >
              <span v-else>Sin Firma</span>
            </v-flex>
          </v-layout>
        </v-card-text>

        <!-- Notas -->
        <v-card-text>
          <h3>Notas</h3>
          <p class="font-weight-light.font-italic grey--text">{{dataPropietario.notas}}</p>
        </v-card-text>

        <v-card-text>
          <v-divider></v-divider>
          <!-- <pre>{{files}}</pre> -->
          <h3>Lista de archivos</h3>
          <v-list two-line>
            <v-list-tile avatar v-for="(file, i) in files" :key="i">
              <v-list-tile-content>
                <v-list-tile-title>
                  {{i + 1}} - <span class="teal--text">{{ file.name }}: </span> <a :href="file.data.downloadURL" target="_blank" rel="noopener noreferrer">{{file.data.name}} </a>
                  <!-- <a href="https://firebasestorage.googleapis.com/v0/b/app-users-cloud.appspot.com/o/users-forms%2F0052401VK4705C%2F13%2Fform-1565517273936-sce49exypa%2F1565518386932..jpg?alt=media&token=bf0cf30a-77f4-43cd-9c55-4b7d655fe5a5" target="_blank" rel="noopener noreferrer">Alquiler_1</a> -->
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <p v-if="files.length < 1"><span class="teal--text"> * No hay archivos</span></p>
        </v-card-text>

      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
const modelPropietario = {
  "autorizarDatos": "1",
  "calificacionJuridica": "1",
  "direccion": {
    "calle": "",
    "ciudad": "",
    "cp": "",
    "escalera": "",
    "letra": "",
    "piso": "",
    "provincia": ""
  },
  "empadronado": "",
  "filesAlquiler": [],
  "filesDiscapacidad": [],
  "filesEmpadronamiento": [],
  "filesNifCif": [],
  "filesPadron": [],
  "filesRenta": [],
  "firma": "",
  "notas": "",
  "pFisica": {
    "apellido1": "",
    "apellido2": "",
    "discapacidad": {
      "documentoDiscapacidad": false,
      "grado": "",
      "isDiscapacidad": "0",
      "movilidad": "0",
      "tipo": false
    },
    "email": "",
    "fechaNacimiento": "",
    "ipremX3": "",
    "nif": "",
    "nombre": "",
    "tlf1": "",
    "tlfs": ""
  },
  "pJuridica": {
    "apoderado": {
      "email": "",
      "nif": "",
      "nombreApellidos": "",
      "tlf1": "",
      "tlfs": []
    },
    "cif": "",
    "razonSocial": ""
  },
  "privacidad": true,
  "relacionInmueble": {
    "description": null,
    "propiedadPercent": 0,
    "tipo": "0"
  },
  "tipoInmueble": {
    "description": null,
    "tipo": "0"
  }
}
const modelAuthDataAN = {
  ayudas: "1",
  dependencia: "1",
  discapacidad: "1",
  dni: "1",
  grupoEspecial: "1",
  padron: "1",
  renta: "1",
  renta1: "1",
  tgss: "1"
}
export default {
  props: ["propietario", "uid", "refCatastral", "idInmueble", "CA"],
  data() {
    return {
      iprem: null,
      espacialAuthData: [
        {
          text_1: 'Presto mi CONSENTIMIENTO para la consulta de mis datos de identidad a través del Sistema de Verificación de Datos de Identidad.',
          text_2: 'NO CONSIENTO y aporto copia del DNI/NIE.',
          value: '1',
          campo: 'dni',
          file: 'filesNifCif',
          meta: 'DNI NIF NIE',
          condiResidencia: false,
          condiDiscapacidad: false
        },
        {
          text_1: 'Presto mi CONSENTIMIENTO para la consulta de la Tesorería General de la Seguridad Social.',
          text_2: 'NO CONSIENTO y aporto las certificaciones correspondientes.',
          value: '1',
          campo: 'tgss',
          file: 'filesTgss',
          meta: 'Tesorería General de la Seguridad Social',
          condiPropietario: true,
          condiResidencia: false,
          condiDiscapacidad: false
        },
        {
          text_1: 'Presto mi CONSENTIMIENTO para la consulta de la Consejería competente en materia de Hacienda y Agencia Estatal de la Administración Tributaria.',
          text_2: 'NO CONSIENTO y aporto las certificaciones correspondientes.',
          value: '1',
          campo: 'renta1',
          file: 'filesRenta1',
          meta: 'renta autonómica',
          condiPropietario: true,
          condiResidencia: false,
          condiDiscapacidad: false
        },
        {
          text_1: 'Presto mi CONSENTIMIENTO para la consulta sobre otras convocatorias de ayudas a la rehabilitación de la Consejería competente en materia de vivienda.',
          text_2: 'NO CONSIENTO y aporto las certificaciones correspondientes.',
          value: '1',
          campo: 'ayudas',
          file: 'filesAyudas',
          meta: 'otras convocatorias de ayudas',
          condiPropietario: true,
          condiResidencia: false,
          condiDiscapacidad: false
        },
        {
          text_1: 'Presto mi CONSENTIMIENTO para la consulta de mis datos de la Agencia Estatal de la Administración Tributaria.',
          text_2: 'NO CONSIENTO y aporto documentación relativa a mis ingresos económicos.',
          value: '1',
          campo: 'renta',
          file: 'filesRenta',
          meta: 'renta',
          condiResidencia: true,
          condiDiscapacidad: false
        },
        {
          text_1: 'Presto mi CONSENTIMIENTO para la consulta de Residencia.',
          text_2: 'NO CONSIENTO y aporto certificado del Padrón municipal correspondiente.',
          value: '1',
          campo: 'padron',
          file: 'filesPadron',
          meta: 'certificado empadronamiento',
          condiResidencia: true,
          condiDiscapacidad: false
        },
        {
          text_1: 'Presto mi CONSENTIMIENTO para la consulta de los datos de Discapacidad (Grado y Tipo).',
          text_2: 'NO CONSIENTO y aporto las certificaciones correspondientes.',
          value: '1',
          campo: 'discapacidad',
          file: 'filesDiscapacidad',
          meta: 'certificado discapacidad',
          condiPropietario: true,
          condiResidencia: true,
          condiDiscapacidad: true
        },
        {
          text_1: 'Presto mi CONSENTIMIENTO para la consulta de los datos de Dependencia (Grado III).',
          text_2: 'NO CONSIENTO y aporto las certificaciones correspondientes.',
          value: '1',
          campo: 'dependencia',
          file: 'filesDependencia',
          meta: 'Dependencia',
          condiPropietario: true,
          condiResidencia: true,
          condiDiscapacidad: true
        },
        {
          text_1: 'Presto mi CONSENTIMIENTO para la consulta sobre Grupo de especial protección, definidos en el Plan de Vivienda y Rehabilitación de Andalucía 2016-2020',
          text_2: 'NO CONSIENTO y aporto las certificaciones correspondientes.',
          value: '1',
          campo: 'grupoEspecial',
          file: 'filesGrupoEspecial',
          meta: 'Grupo de especial protección',
          condiResidencia: true,
          condiDiscapacidad: true
        }
      ],
      visualiza: true,
      invita: false,
      menu: {
        items: [
          { title: 'Consolidar', action: 'consolida' },
          { title: 'Click Me', action: '' },
          { title: 'Click Me', action: '' }
        ]
      },
      color: "purple lighten-5",
      flat: false,
      media: false,
      loading: true,
      actions: true,
      outlined: false,
      elevation: undefined,
      raised: false,
      width: 344,
      height: undefined
    }
  },

  computed: {
    dataPropietario() {
      let model = modelPropietario
      if (this.CA === 'AN') {
        model.authData = modelAuthDataAN
      }
      const d = Object.assign({}, model, this.propietario)
      return d
    },

    files() {
      let result = []

      const filesData = [
        ["filesAlquiler", "Alquiler"],
        ["filesDiscapacidad", "Discapacidad"],
        ["filesEmpadronamiento", "Empadronamiento"],
        ["filesNifCif", "NIF/CIF"],
        ["filesPadron", "Padrón"],
        ["filesRenta", "Renta"],
        ["filesAlquilerAcuerdo", "Acuerdo"],
        ["filesAyudas", "Ayudas"],
        ["filesDeclaraResponsable", "Declaración"],
        ["filesDependencia", "Dependencia"],
        ["filesGrupoEspecial", "G.Especial"],
        ["filesRenta1", "Renta_1"],
        ["filesTgss", "TGSS"]
      ]

      filesData.forEach(element => {
        const data = this.filesArray(this.dataPropietario[element[0]], element[1])
        if (data) {
          data.forEach(d => {
            result.push(d)
          })
        }
      })

      return result

    },

    tipoInmueble() {
      if (!this.dataPropietario.tipoInmueble) {
        return ' * Sin especificar'
      }
      if (this.dataPropietario.tipoInmueble.tipo === '0') {
        return 'Vivienda'
      }
      if (this.dataPropietario.tipoInmueble.tipo === '1') {
        return 'Local comercial'
      }
      if (this.dataPropietario.tipoInmueble.tipo === '2') {
        return `Otro - ${this.dataPropietario.tipoInmueble.description ? this.dataPropietario.tipoInmueble.description : ' * Sin descripción'}`
      }
      return ' * No Existe el dato *'
    },

    relacionInmueble() {
      if (!this.dataPropietario.relacionInmueble) {
        return ' * Sin especificar'
      }
      if (this.dataPropietario.relacionInmueble.tipo === '1') {
        return 'Propietario/a'
      }
      if (this.dataPropietario.relacionInmueble.tipo === '2') {
        return 'Inquilino/a'
      }
      if (this.dataPropietario.relacionInmueble.tipo === '3') {
        return `Otro - ${this.dataPropietario.relacionInmueble.description ? this.dataPropietario.relacionInmueble.description : ' * Sin descripción'}`
      }
      return ' * No Existe el dato *'
    },

    isEmpadronado() {
      if (this.dataPropietario.empadronado === '1') {
        return 'SI'
      }
      if (this.dataPropietario.empadronado === '2') {
        return 'NO'
      }
      if (this.dataPropietario.empadronado === '3') {
        return 'NO, pero puedo empadronarme'
      }
      return ' * No Existe el dato *'
    },
    isEmpresa() {
      if (!this.dataPropietario || !this.dataPropietario.calificacionJuridica) {
        return false;
      }
      const val = parseInt(this.dataPropietario.calificacionJuridica) === 2;
      return val;
    },

    nombreApellidos() {
      if (this.isEmpresa) {
        return `${this.dataPropietario.pJuridica.apoderado.nombreApellidos}`;  
      }
      return `${this.dataPropietario.pFisica.nombre} ${this.dataPropietario.pFisica.apellido1} ${this.dataPropietario.pFisica.apellido2}`
    },

    fechaNacimiento() {
      if (this.isEmpresa) {
        return {
          fecha: 'No Aplica',
          edad: ' ? '
        }
      }
      if (!this.dataPropietario.pFisica.fechaNacimiento || this.dataPropietario.pFisica.fechaNacimiento.length < 10) {
        return {
          fecha: 'No Existe el dato',
          edad: ' ? '
        }
      }
      const d = new Date(this.dataPropietario.pFisica.fechaNacimiento)
      return {
        fecha: d.toLocaleDateString(),
        edad: this.calcularEdad(d)
      }
    }
  },

  methods: {
    checkCondi(item) {
      /* if (!this.dataPropietario || !this.dataPropietario.authData || !this.dataPropietario.authData.hasOwnProperty(item.campo)) {
        console.log(`no existe el campo ${item.campo}`)
        console.log(this.dataPropietario)
        return false
      } */
      // !item.condiResidencia || (allForms.form2 && allForms.form2.empadronado === '1')
      const isPropietario = this.dataPropietario.relacionInmueble.tipo === '1'
      const isEmpadronado = this.dataPropietario.empadronado === '1'
      const isDiscapacidad = this.dataPropietario.pFisica.discapacidad.isDiscapacidad
      
      const condiResidencia = item.condiResidencia
      const condiPropietario = item.condiPropietario
      const condiDiscapacidad = item.condiDiscapacidad

      if (condiPropietario && !isPropietario) {
        return false
      }

      if (condiResidencia && !isEmpadronado) {
        return false
      }

      if (condiDiscapacidad && !isDiscapacidad) {
        return false
      }
      return true
    },

    changeIprem() {
      switch (this.iprem) {
        case '1':
          this.dataPropietario.pFisica.ipremX3 = '1'
          this.dataPropietario.pFisica.ipremX = '1'
          break;
        case '2':
          this.dataPropietario.pFisica.ipremX3 = '2'
          this.dataPropietario.pFisica.ipremX = '1'
          break;
        case '3':
          this.dataPropietario.pFisica.ipremX3 = '2'
          this.dataPropietario.pFisica.ipremX = '2'
          break;
        case '4':
          this.dataPropietario.pFisica.ipremX3 = '3'
          this.dataPropietario.pFisica.ipremX = '3'
          break;
      
        default:
          this.dataPropietario.pFisica.ipremX3 = null
          this.dataPropietario.pFisica.ipremX = null
          break;
      }
      console.log(`cambio IPREM: ipremX3 = ${this.dataPropietario.pFisica.ipremX3}, ipremX = ${this.dataPropietario.pFisica.ipremX}`)
    },

    filesArray(files, name) {
      let result = []
      if (files && files.length > 0) {
        let index = 0
        files.forEach(element => {
          index++
          result.push({
            name: `${name} #${index}`,
            data: element
          })
        });
      }
      return result.length > 0 ? result : null
    },

    calcularEdad(fecha) {
      var hoy = new Date();
      var cumpleanos = new Date(fecha);
      var edad = hoy.getFullYear() - cumpleanos.getFullYear();
      var m = hoy.getMonth() - cumpleanos.getMonth();

      if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
          edad--;
      }

      return edad;
    }
  }
}
</script>
